var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose } from 'class-transformer';
import { IsDateString, IsNumber, IsString, IsUUID } from 'class-validator';
import { ChallengeType } from '../enums/challenge-type.enum.js';
export class OfficeAchievementLevelChallengeResponseDto {
    id;
    createdAt;
    updatedAt;
    challengeLabel;
    currentCount;
    totalCount;
    challengeType;
}
__decorate([
    IsUUID(),
    Expose(),
    IsString(),
    __metadata("design:type", String)
], OfficeAchievementLevelChallengeResponseDto.prototype, "id", void 0);
__decorate([
    Exclude(),
    IsDateString(),
    __metadata("design:type", Date)
], OfficeAchievementLevelChallengeResponseDto.prototype, "createdAt", void 0);
__decorate([
    Exclude(),
    IsDateString(),
    __metadata("design:type", Date)
], OfficeAchievementLevelChallengeResponseDto.prototype, "updatedAt", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], OfficeAchievementLevelChallengeResponseDto.prototype, "challengeLabel", void 0);
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], OfficeAchievementLevelChallengeResponseDto.prototype, "currentCount", void 0);
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], OfficeAchievementLevelChallengeResponseDto.prototype, "totalCount", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], OfficeAchievementLevelChallengeResponseDto.prototype, "challengeType", void 0);
//# sourceMappingURL=office-achievement-level-challenge.response.dto.js.map